import mickeyMouse from "@/api/mickey-mouse"
import me from "@/api/me"
import books from "@/api/books"
import blocklist from "@/api/blocklist"
import organisations from "@/api/organisations"
import settings from "@/api/settings"
import plans from "@/api/plans"
import purchase from "@/api/purchase"
import teams from "@/api/teams"
import churnPrevention from "@/api/churn-prevention"
import consents from "@/api/cookie-consents"
import ratings from "@/api/ratings"
import backendEvents from "@/api/backend-events"
import categories from "@/api/categories"
import guideProgress from "@/api/guide-progress"
import appInstallQrCode from "@/api/app_install_qr_code"

export default {
  mickeyMouse,
  me,
  books,
  blocklist,
  organisations,
  settings,
  plans,
  purchase,
  teams,
  churnPrevention,
  consents,
  ratings,
  backendEvents,
  categories,
  guideProgress,
  appInstallQrCode
}
